import { SerializedPresaveWidget, SerializedSmartLink } from 'fym-common/src/db/serializersTypes';
import { SmartLinkWidgetType } from 'fym-common/src/db/enums';

/**
 * A SmartLink knows its campaign only through this block: the serialised page
 * carries the campaign's uuid inside the pre-save widget's data and nothing
 * else. One page has at most one campaign, so the first match is the one.
 */
export function findPresaveWidget(smartLink: SerializedSmartLink | undefined): SerializedPresaveWidget | undefined {
  const widgets = smartLink?.recentSmartLinkVersion?.widgets;
  if (!widgets) {
    return undefined;
  }
  // A "Catalog links" block with no campaign (a song that is out) is not a pre-save.
  return widgets.find(
    (widget): widget is SerializedPresaveWidget =>
      widget.type === SmartLinkWidgetType.presave && (widget as SerializedPresaveWidget).data.hasCampaign !== false
  );
}
